module.exports = __webpack_public_path__ + "img/downloading.8daaf7c5.png";